import { Button, Heading } from "iparque-components";
import { useMessageContext } from "providers/MessageProvider";
import React from "react";
import { useTranslation } from "react-i18next";
import styled from "styled-components";

interface Props {
  className?: string;
}

const Success: React.FC<Props> = ({ className }) => {
  const { t } = useTranslation();
  const { onResetPrompt } = useMessageContext();

  return (
    <div className={className}>
      <StyledHeading variant="h5">
        {t("10173") /* Obrigada pela sua mensagem */}
      </StyledHeading>
      <StyledHeading variant="h6">
        {t("10174") /* Em breve será contactado pela nossa equipa comercial */}
      </StyledHeading>
      <StyledButton color="secondary" className="mt-20" onClick={onResetPrompt}>
        {t("9") /* Voltar */}
      </StyledButton>
    </div>
  );
};

export default Success;

const StyledHeading = styled(Heading)`
  line-height: 1.2em;
`;

const StyledButton = styled(Button)`
  float: right;
`;
